import { template } from "@ember/template-compiler";
import type { Signature as DiagnosticFieldsSignature } from '../breast-cancer/diagnostic-fields';
import DiagnosticFields from '../breast-cancer/diagnostic-fields';
import type { TOC } from '@ember/component/template-only';
interface Signature {
    Args: Pick<DiagnosticFieldsSignature['Args'], 'form' | 'patient'>;
}
const MedicalHistoryFormBreastTNM0CancerDiagnosticFieldsComponent: TOC<Signature> = template(`
    <DiagnosticFields @form={{@form}} @patient={{@patient}} />
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export default MedicalHistoryFormBreastTNM0CancerDiagnosticFieldsComponent;
